<template>
  <el-dialog
          title="云喇叭配置"
          :visible.sync="dialogVisible"
          append-to-body
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
                    prop="state"
                    label="状态"
      >
        <el-switch
                v-model="form.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="0"
                inactive-value="1"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
              prop="sb_sn"
              label="设备ID"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.sb_sn"></el-input>
      </el-form-item>
      <el-form-item
              prop="voice_state"
              label="语音启动"
      >
        <el-switch
                v-model="form.voice_state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="0"
                inactive-value="1"
                >
        </el-switch>
      </el-form-item>

      <el-form-item label="类型" prop="type"  :rules="[{ required: true, message: '不能为空'}]">
        <el-select
                class="filter-item"
                v-model="form.type"
                placeholder="类型"
                width="50"
        >
          <el-option
                  v-for="item in sfzlxOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="voice_content"
              label="语音内容"
      >
        <el-input v-model="form.voice_content"></el-input>
      </el-form-item>
      <el-form-item
              prop="remarks"
              label="备注"
      >
        <el-input v-model="form.remarks"></el-input>
      </el-form-item>



      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>

    import * as userService from "@/api/sys/user";    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "editspeakerForm",
        props: {
            agent: Object,
            accuseVisible:Boolean,
            store_id:Number,
            value: Boolean
        },
        data() {
            return {
                formEdit: true,
                accuseVisible2:true,
                loading: false,
                dialogVisible: false,
              sfzlxOptions: [
                {
                  value: "0",
                  label: "云喇叭"
                },
                {
                  value: "1",
                  label: "B001云喇叭"
                }
              ],
                form: {
                    state: "0",
                    voice_state: "1"
                }

            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
                console.log("--value---"+val);
            },
            accuseVisible (newValue, oldValue) {
                console.log("-----"+newValue);
                this.accuseVisible2 = newValue;
            },

            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dialogOpen() {
                this.$refs.form.resetFields();


                if (this.agent.id) {
                    // userService.getUser(this.user.id).then(data => {
                    let form = {};
                    form.state = this.agent.state;
                    form.sb_sn = this.agent.sb_sn;
                    form.voice_state = this.agent.voice_state;
                    form.voice_content = this.agent.voice_content;
                    form.remarks = this.agent.remarks;
                  form.type = this.agent.type;
                    this.form = form;
                    // });
                    this.formEdit = this.accuseVisible2;
                } else {
                    this.formEdit = this.accuseVisible2;
                    let form = {};
                    form.state="0";
                    form.voice_state="1";
                    this.form = form;
                }
            },
            saveUser() {
                this.$refs["form"].validate(valid => {
                    if (valid) {


                                        this.loading = true;
                                        agentService.saveAgentStoreSpeaker({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.id,store_id:this.store_id })
                                            .then(data => {
                                                this.loading = false;
                                                this.dialogVisible = false;
                                                this.$emit("submit");
                                            });


                    } else {
                        return false;
                    }
                });
            },
            close() {
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>

